
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { SurveyResultView, SurveyView } from '../../backend/backendapi';
import { getSignatureImage } from './util';

@Component({
  name: 'SignatureModal',
  components: {},
})
export default class SignatureModal extends Vue {
  survey: SurveyView | null = null;
  result: SurveyResultView | null = null;

  get img(): string {
    if (!this.survey || !this.result) {
      return '';
    }
    return getSignatureImage(this.survey, this.result);
  }

  public open(survey: SurveyView, result: SurveyResultView): void {
    this.survey = survey;
    this.result = result;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.result = null;
    $(this.$refs.modal!).modal('hide');
  }
}
